import React from 'react';

const WhyWorkWithMe = () => {
  return (
    <section id="why-work-with-me" className="why-work-with-me-section">
      <div className="why-work-with-me-container">
        <div className="section-header">
          <h2 className="section-title">Why Work With Me?</h2>
          <p className="section-subtitle">
            What sets me apart as a frontend developer
          </p>
        </div>

        <div className="why-work-grid">
          <div className="why-work-card">
            <div className="why-work-icon">🚀</div>
            <h3 className="why-work-title">Performance</h3>
            <p className="why-work-description">Optimized applications achieving 90+ Lighthouse scores consistently</p>
          </div>
          <div className="why-work-card">
            <div className="why-work-icon">♿</div>
            <h3 className="why-work-title">Accessibility</h3>
            <p className="why-work-description">WCAG 2.1 AAA compliance and inclusive design principles</p>
          </div>
          <div className="why-work-card">
            <div className="why-work-icon">🎯</div>
            <h3 className="why-work-title">Scalability</h3>
            <p className="why-work-description">Architected systems handling millions of transactions safely</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyWorkWithMe;

